import { render, staticRenderFns } from "./policyDetail.vue?vue&type=template&id=0128e2c7&scoped=true&"
import script from "./policyDetail.vue?vue&type=script&lang=js&"
export * from "./policyDetail.vue?vue&type=script&lang=js&"
import style0 from "./policyDetail.vue?vue&type=style&index=0&id=0128e2c7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0128e2c7",
  null
  
)

export default component.exports